import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Production-safe session: rely on HttpOnly cookie set by backend on login/register.
// `withCredentials: true` ensures the browser sends the cookie on cross-origin requests.
// Legacy Bearer token support (used only by non-browser tests / mobile PWA) is still
// accepted by the backend, but the browser client no longer stores JWT in localStorage.
export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatErr(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fileUrl(pathOrUrl) {
  if (!pathOrUrl) return null;
  if (pathOrUrl.startsWith("http")) return pathOrUrl;
  if (pathOrUrl.startsWith("/api/")) return `${BACKEND_URL}${pathOrUrl}`;
  return `${API}/files/${pathOrUrl}`;
}
